// https://developers.google.com/youtube/player_parameters
import React, { useState, useEffect, useRef } from 'react';
import { useUser } from "../context/UserContext";
import YouTube from 'react-youtube';
import VideoItem from './VideoItem';

export default function YouTubeViewer({
    videoId,
    onEnd,
    height,
    width
}) {
    const { setUser } = useUser();
    const [playing, setPlaying] = useState(false);
    // const containerRef = useRef(null);
    // const iframeRef = useRef(null);
    // const [isMobile, setIsMobile] = useState(false);
    // const youtubeRef = useRef(null);

    // useEffect(() => {
    //     // const checkMobile = () => {
    //     //     const userAgent = navigator.userAgent || window.opera;
    //     //     const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    //     //     const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            
    //     //     return mobileRegex.test(userAgent) || isTouchDevice;
    //     // };

    //     // mobile devices only, excluded touch screen laptops
    //     // only on mobile devices, embedded YouTube does not autoplay
    //     const checkMobile = () => {
    //         const userAgent = navigator.userAgent;
    //         const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            
    //         return mobileRegex.test(userAgent);
    //     };

    //     // const thisMobile = checkMobile();
    //     const thisMobile = checkMobile() || true;
    //     // console.log(thisMobile);
    //     setIsMobile(thisMobile);
    // }, []);

    // useEffect(() => {
    //     // if (!isMobile || !containerRef?.current) return;
    //     if (!isMobile) return;

    //     const timer = setTimeout(() => {
    //         const container = containerRef?.current;
    //         const rect = container.getBoundingClientRect();
            
    //         // Calculate center coordinates
    //         const centerX = rect.left + rect.width / 2;
    //         const centerY = rect.top + rect.height / 2;

    //         // const iframeEvent = new MouseEvent('click', {
    //         //     view: window,
    //         //     bubbles: true,
    //         //     cancelable: true,
    //         //     clientX: centerX,
    //         //     clientY: centerY,
    //         //     screenX: centerX,
    //         //     screenY: centerY,
    //         // });
    //         // console.log(iframeRef);
    //         // console.log(iframeRef?.current);
    //         // // iframeRef?.current.dispatchEvent(iframeEvent);
    //         // iframeRef?.current.click();

    //         const clickEvent = new MouseEvent('click', {
    //             view: window,
    //             bubbles: true,
    //             cancelable: true,
    //             clientX: centerX,
    //             clientY: centerY,
    //             screenX: centerX,
    //             screenY: centerY,
    //         });
            
    //         const targetElement = document.elementFromPoint(centerX, centerY);
    //         if (!targetElement) return;
    //         console.log(targetElement);
    //         targetElement.click();
    //         targetElement.dispatchEvent(clickEvent);

    //         // Create touch event
    //         const touchStartEvent = new TouchEvent('touchstart', {
    //             bubbles: true,
    //             cancelable: true,
    //             touches: [
    //                 new Touch({
    //                     identifier: 0,
    //                     target: targetElement,
    //                     clientX: centerX,
    //                     clientY: centerY,
    //                     pageX: centerX + window.pageXOffset,
    //                     pageY: centerY + window.pageYOffset,
    //                     screenX: centerX,
    //                     screenY: centerY,
    //                 })
    //             ],
    //             targetTouches: [
    //                 new Touch({
    //                     identifier: 0,
    //                     target: targetElement,
    //                     clientX: centerX,
    //                     clientY: centerY,
    //                     pageX: centerX + window.pageXOffset,
    //                     pageY: centerY + window.pageYOffset,
    //                     screenX: centerX,
    //                     screenY: centerY,
    //                 })
    //             ],
    //             changedTouches: [
    //                 new Touch({
    //                     identifier: 0,
    //                     target: targetElement,
    //                     clientX: centerX,
    //                     clientY: centerY,
    //                     pageX: centerX + window.pageXOffset,
    //                     pageY: centerY + window.pageYOffset,
    //                     screenX: centerX,
    //                     screenY: centerY,
    //                 })
    //             ]
    //         });

    //         // Dispatch the touch event
    //         targetElement.dispatchEvent(touchStartEvent);

    //         // Optional: Also trigger touchend after a short delay
    //         setTimeout(() => {
    //             const touchEndEvent = new TouchEvent('touchend', {
    //             bubbles: true,
    //             cancelable: true,
    //             touches: [],
    //             targetTouches: [],
    //             changedTouches: [
    //                 new Touch({
    //                 identifier: 0,
    //                 target: targetElement,
    //                 clientX: centerX,
    //                 clientY: centerY,
    //                 pageX: centerX + window.pageXOffset,
    //                 pageY: centerY + window.pageYOffset,
    //                 screenX: centerX,
    //                 screenY: centerY,
    //                 })
    //             ]
    //             });

    //             targetElement.dispatchEvent(touchEndEvent);
    //         }, 200);
    //     }, 3000);

    //     return () => clearTimeout(timer);
    // }, [isMobile]);

    // const handleClick = (e) => {
    //     console.log('Clicked');
    //     console.log(e.clientX, e.clientY);
    // };

    // const handleTouchStart = (e) => {
    //     console.log('Touch started');
    //     console.log(e.touches[0].clientX, e.touches[0].clientY);
    // };

    // const handleTouchEnd = () => {
    //     console.log('Touch ended');
    // };
    
    // const delay = async (ms) => {
    //     return new Promise(resolve => setTimeout(resolve, ms));
    // };
   
    // const handleReady2 = async (e) => {
    //     console.log('Ready');
    //     console.log(e);
    //     console.log(e.target.getPlayerState());

    //     youtubeRef.current = e.target;
    //     // youtubeRef.current?.playVideo();

    //     await delay(20000);

    //     // state = 5/cued, due to test site origin https://192.168.86.60:3000 different from YouTube expected
    //     // Failed to execute 'postMessage' on 'DOMWindow': The target origin provided ('https://www.youtube.com') does not match the recipient window's origin ('https://localhost:3000').
    //     // i.e. cannot process PostMessage()
    //     // i.e. video not auot play will not happen in PRD site
    //     const checkState = setInterval(() => {
    //         const thisState = youtubeRef.current?.getPlayerState();
    //         console.log(thisState);
    //         // youtubeRef.current?.playVideo();

    //         try {
    //             if (thisState === -1) {
    //                 console.log("Cued video");
    //                 youtubeRef.current?.cueVideoById(videoId);
    //             }

    //             if (thisState === 5) {
    //                 console.log("Starting video");
    //                 youtubeRef.current?.playVideo();
    //                 clearInterval(checkState);
    //             }
    //         } catch (error) {
    //             console.log(error);
    //         }

    //     }, 5000);
    // };

    // const handleReady = (e) => {
    //     console.log('Ready');
    //     console.log(e);
    // };

    const handleStateChange = (e) => {
        // console.log('State');
        // console.log(e);
        // e.target.playVideo();

        if (!playing && (e.data === 1 || e.data === 3 )) {
            setPlaying(true);
            // console.log('Playing', e);

            // increment play count only when playing the first time
            setUser(profile => {
                const playCounts = profile.playCounts || {};

                return {
                    ...profile,
                    playCounts: {
                        ...playCounts,
                        [videoId]: (playCounts[videoId] || 0) + 1
                    }
                };
            });
        }
    };

    useEffect(() => {
        // console.log(videoId);
        setPlaying(false);
    }, [videoId]);
    
    // useEffect(() => {
    //     if (user.playCounts) {
    //         console.log(user.playCounts);
    //     }
    // }, [user.playCounts]);
    
    const videoOpts = {
        height: `${height}`,
        width: `${width}`,
        playerVars: {
            autoplay: 1,
            controls: 1,
            rel: 0,
        },
    };

    return (
        <div className="relative rounded-lg overflow-hidden group"
            // ref={containerRef}
            // onTouchStart={handleTouchStart}
            // onTouchEnd={handleTouchEnd}
        >
            {(!videoId || videoId === '') ? 
            <>
                <VideoItem
                />
                <div className="absolute inset-0"></div>
            </>
            :
            <>
                <YouTube
                    // ref={iframeRef}
                    videoId={videoId}
                    opts={videoOpts}
                    onEnd={onEnd}
                    // onReady={handleReady}
                    onStateChange={handleStateChange}
                />
            </>
            }
        </div>
    )
}

